module.exports = "/assets/data/8968bb145df7700c89a8377b193d7d82-IP27.data.json";